<template>
    <div class="dashboard">
        <div id="topnav" class="mui-panel">
            <img id="logo" src="../assets/logo.png" alt="logo">
            <div class="mui--pull-right"><router-link to="logout">Logout</router-link></div>
            <div v-if="admin" class="mui--pull-right"><router-link to="admin">Admin</router-link></div>
            <div class="mui--pull-right"><router-link to="sku">SKU</router-link></div>
            <div class="mui--pull-right"><router-link to="catalog">Catalog</router-link></div>
        </div>
        <div id="content" class="mui-panel">
            <router-view/>
        </div>
    </div>
</template>

<script>
import router from '@/router'
import store from '@/store'

export default {
    name: 'dashboard',
    data() {
        return {
            admin: store.state.admin
        }
    },
    beforeCreate() {
        if (!store.state.isLogged) {
            router.push('/')
        }
        else {
            router.push('/catalog')
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mui-panel {
    margin-bottom: 5px;
}
.dashboard {
    margin-top: 5px;
}
#topnav > div {
    padding-top: 20px;
    padding-right: 10px;
}
#logo {
    float: left;
    max-width: 250px;
}
</style>



// WEBPACK FOOTER //
// Dashboard.vue?7ea957c2